import { createAgnosticStrongAuthRepository } from 'auth/infra/createAgnosticStrongAuthRepository'

import { CHAT_BACKEND_URL } from '../../infra/environment'
import { HttpClient, createTokenInterceptor } from '../../infra/http/HttpClient'

export function createChatHttpClient(accessToken?: string) {
  const userRepository = accessToken
    ? { getLocalToken: () => accessToken }
    : createAgnosticStrongAuthRepository()
  const httpClient = new HttpClient(CHAT_BACKEND_URL, {
    requestInterceptor: createTokenInterceptor({ userRepository }),
    responseInterceptor: null,
  })

  return httpClient
}
